const drink = [
    {
        id: 1,
        name: 'Organic juice',
        price: '2.60'
    },
    {
        id: 2,
        name: 'Coffee',
        price: '3.00'
    },
    {
        id: 3,
        name: 'Spirits',
        price: '5.10'
    },
    {
      id: 4,
      name: 'Tea',
      price: '2.20'
    },
    {
      id: 5,
      name: 'Water',
      price: '1.49'
    }
];

export default drink;